<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h2 class="h4 m-0 mx-auto"> {{ $t("about") }} </h2>
            </div>
            <div class="row">
                <div class="sections p-3">
                    <p class="text-justify m-0 mb-2">  {{ $t("about_text") }} </p>
                    <div class="text-center">
                        <vs-button class="d-inline" href="/AbolfazlMohajeriResume.pdf" blank transparent active color="#22333B">
                            {{ $t("download_cv") }}
                        </vs-button>
                        <vs-button class="d-inline" transparent active color="#22333B" id="contact-btn">
                            {{ $t("contact_me") }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery"

    export default {
        name: "About",
        mounted() {
            $("#contact-btn").on("click", function (e) {
                e.preventDefault();
                let myElement = document.getElementById("contact");
                let topPos = myElement.offsetTop;
                window.scrollTo({
                    top: topPos - 50,
                    behavior: "smooth"
                });
            });
        }
    }
</script>

<style>

</style>

<style scoped>

</style>
